export default __webpack_public_path__ + "static/4-2d2c4da3d8a702f88d9431d666a05723.jpeg";